import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  cn,
} from '@repo/ui';
import type { JSX } from 'react';
import { Link } from '@/components/link';
import type { IBreadcrumbItem } from './types';

interface IBreadcrumbNavProps {
  items: IBreadcrumbItem[];
  className?: string;
}

export function BreadcrumbNav({ items, className }: IBreadcrumbNavProps): JSX.Element {
  if (items.length === 0) {
    return <> </>;
  }

  return (
    <Breadcrumb className={cn('min-w-0', className)}>
      <BreadcrumbList className="flex-nowrap overflow-x-auto whitespace-nowrap select-none [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.flatMap((item, index) => {
          const isLast = index === items.length - 1;
          const elements: JSX.Element[] = [];

          if (index > 0) {
            // biome-ignore lint/suspicious/noArrayIndexKey: breadcrumb items have no stable id
            elements.push(<BreadcrumbSeparator key={`separator-${index}`} />);
          }

          elements.push(
            // biome-ignore lint/suspicious/noArrayIndexKey: breadcrumb items have no stable id
            <BreadcrumbItem key={`item-${index}`}>
              {isLast ? (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link href={item.href}>{item.label}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>,
          );

          return elements;
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
